<div [formGroup]="frm">
  <div class="input-group">
    <label class="ms-Label" [for]="formControlName">{{label}}</label>
    <input [formControlName]="formControlName" class="form-check" type="checkbox"/>
  </div>
</div>
